'use client';

import StrapiErrorPage from '@/components/StrapiErrorPage';
import { ERROR_CONFIG } from '@/config/error-config';

/**
 * Global Error Boundary
 * 
 * Catches errors thrown in layout.tsx (including RootLayout)
 * and other global contexts. This is required because regular
 * error.tsx only catches errors in page.tsx and its children,
 * not in layouts.
 * 
 * Used when layout.tsx fails to fetch global data (social media,
 * footer motto, etc.) from Strapi.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <head>
        <title>500 - Service Unavailable</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css" />
      </head>
      <body>
        <StrapiErrorPage 
          error={error} 
          reset={reset} 
          countdown={ERROR_CONFIG.RETRY_COUNTDOWN_SECONDS}
          maxRetries={ERROR_CONFIG.MAX_RETRY_ATTEMPTS}
        />
      </body>
    </html>
  );
}
